export enum HomeCardsRoutes {
    ROUTE_PAYMENTS = "/v1/#/inicio/mis-pagos",
    ROUTE_HEALTH_MAP = "/v1/#/salud/mapa/",
    ROUTE_DOCUMENTS_DOWNLOAD = "/descargar-documentos",
    ROUTE_SOAT_DOCUMENTS_DOWNLOAD = "/descargar-documentos-soat",
    ROUTE_VEHICLES_MAP = "/v1/#/autos/mapa/",
    ROUTE_SEE_VEHICLE_ROUTE = "/v1/#/autos/AEPlanKilometros/mi-recorrido/:systemCode/:policyId",
    ROUTE_CORONAVIRUS_INFO = "/v1/#/inicio/info-coronavirus?productos=:products",
    MEDICINE_DELIVERY = "/solicitudes/delivery-medicamentos",
    REPAYMENT_OBLIGATIONS = "/solicitudes/registro/devolucion-dinero",
    VEHICULAR_ASSISTANCE = "/asistencia-vehicular/inicio-solicitud",
    COVID_NEXT_STEPS = "/covid-siguientes-pasos",
    REQUESTS_TRACKING = "/mis-tramites",
    ROUTE_BENEFITS_VEHICLE = "/beneficios/descuentos/autos",
    HEALTH_REIMBURSEMENT_REQUEST = "/mis-tramites/solicitud",
}
